// extracted by mini-css-extract-plugin
export default {"card":"Buttons_card__dRtej","title":"Buttons_title__6rXLw","image":"Buttons_image__VoS-w","name":"Buttons_name__LJnOR","price":"Buttons_price__jOfbM"};